import loadable from '@loadable/component';

const GalleryModal = loadable(() => import('./GalleryModal'));

export default GalleryModal;
